<div class="edit-mapping-slideout">
  <div class="edit-mapping-slideout__tabs">
    <atn-ds-integrated-horizontal-tabs>
      <ng-template
        atnDsTab
        name="Mapping"
      >
        <atn-mapping-tab />
      </ng-template>
      <ng-template
        atnDsTab
        name="Rules"
      >
        <atn-rules-tab />
      </ng-template>
      <ng-template
        atnDsTab
        name="Details"
        ><atn-details-tab
      /></ng-template>
    </atn-ds-integrated-horizontal-tabs>
  </div>
  <div class="edit-mapping-slideout__footer">
    <atn-ds-button
      class="edit-mapping-slideout__footer-cancel-btn"
      (click)="cancelBtnClickHandler()"
      type="transparent"
      >Close</atn-ds-button
    >
  </div>
</div>
